export default "__VITE_ASSET__BzvcmsFA__"